document.addEventListener("DOMContentLoaded", function () {
  let currentCount = 11;
  let searchCountElement = document.querySelector(".js-search-count");
  let loadMoreButton = document.querySelector(".js-load-more-results");
  let searchResults = document.querySelector(".js-search-results");
  let progressBar = document.querySelector(".js-progress-bar");

  let totalCount = searchCountElement ? parseInt(searchCountElement.getAttribute("data-results-count"), 10) : 0;

  if (loadMoreButton && searchResults && searchCountElement && progressBar) {
    let buttonTextSpan = loadMoreButton.querySelector("span");
    let originalText = buttonTextSpan ? buttonTextSpan.textContent : "Load More";
    let loadingText = loadMoreButton.getAttribute("data-loading-text") || "Loading...";

    function updateProgressBar() {
      let progress = (currentCount / totalCount) * 100;
      progressBar.style.width = `${progress}%`;
    }
    updateProgressBar();

    loadMoreButton.addEventListener("click", function () {
      if (currentCount >= totalCount) {
        loadMoreButton.style.display = "none";
        return;
      }

      if (buttonTextSpan) {
        buttonTextSpan.textContent = loadingText;
      }

      let nextPage = Math.ceil(currentCount / 11) + 1;
      
      fetch(`/search?q=${encodeURIComponent(document.querySelector('.js-search-input').value)}&type=product&page=${nextPage}`)
        .then(response => response.text())
        .then(data => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, "text/html");
          let newItems = doc.querySelectorAll(".js-search-results > *"); 

          newItems.forEach(item => searchResults.appendChild(item.cloneNode(true)));
          
          currentCount += newItems.length; 

          if (currentCount >= totalCount) {
            searchCountElement.textContent = totalCount;
          } else {
            searchCountElement.textContent = currentCount;
          }

          updateProgressBar();

          if (currentCount >= totalCount) {
            loadMoreButton.style.display = "none";
          } else if (buttonTextSpan) {
            buttonTextSpan.textContent = originalText;
          }

          setTimeout(function () {
            applyMatchHeightPerRow("[data-match-height]");
            initializeObservers();
          }, 100);
        })
        .catch(error => {
          console.error("Error fetching more results:", error);
          if (buttonTextSpan) {
            buttonTextSpan.textContent = originalText;
          }
        });
    });
  }
});